import React from 'react';
import PropTypes from 'prop-types';

export const CardContainer = ({ children = null }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 370 218"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_36113_220783"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="370"
      height="218">
      <rect width="370" height="218" rx="15.2692" fill="#191919" />
    </mask>
    <g mask="url(#mask0_36113_220783)">
      <rect
        x="370"
        y="219"
        width="370"
        height="220"
        transform="rotate(-180 370 219)"
        fill="#D9D9D9"
      />
      <rect
        x="-6.99951"
        y="-9"
        width="380"
        height="241"
        fill="url(#paint0_linear_36113_220783)"
        fillOpacity="0.5"
      />
      <path d="M388 -26H-21.9995V247H388V-26Z" fill="url(#paint1_linear_36113_220783)" />
      <rect
        x="-0.27832"
        y="0.101562"
        width="370.278"
        height="217.586"
        fill="url(#paint4_linear_36113_220783)"
        fillOpacity="0.3"
      />
      <rect
        x="-0.27832"
        y="0.101562"
        width="370.278"
        height="217.586"
        fill="url(#paint5_linear_36113_220783)"
      />
      <g opacity="0.6">
        <rect
          x="-0.27832"
          y="0.101562"
          width="370.278"
          height="217.586"
          fill="url(#paint6_linear_36113_220783)"
        />
        <rect
          x="-0.27832"
          y="0.101562"
          width="370.278"
          height="217.586"
          fill="url(#paint7_linear_36113_220783)"
        />
      </g>
      <g opacity="0.8">
        <rect
          x="-0.27832"
          width="370.278"
          height="217.586"
          fill="url(#paint8_linear_36113_220783)"
          fillOpacity="0.7"
        />
        <rect
          x="-0.27832"
          width="370.278"
          height="217.586"
          fill="url(#paint9_linear_36113_220783)"
        />
      </g>
      <path
        d="M322.22 26.4666C322.601 20.8425 327.131 16.4493 332.761 16.1616C334.629 16.0661 336.511 16 338.142 16C339.683 16 341.45 16.0591 343.218 16.1463C348.985 16.4307 353.568 21.0229 353.851 26.7903C353.939 28.6031 354 30.419 354 32C354 33.581 353.939 35.3969 353.851 37.2097C353.568 42.9771 348.985 47.5693 343.218 47.8537C341.45 47.9409 339.683 48 338.142 48C336.511 48 334.629 47.9339 332.761 47.8384C327.131 47.5507 322.601 43.1575 322.22 37.5334C322.091 35.6148 322 33.6763 322 32C322 30.3237 322.091 28.3852 322.22 26.4666Z"
        fill="white"
        fillOpacity="0.5"
      />
    </g>
    {children}
    <defs>
      <linearGradient
        id="paint0_linear_36113_220783"
        x1="-6.99951"
        y1="18.1716"
        x2="206.483"
        y2="641.024"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0.64" />
        <stop offset="1" stopColor="white" stopOpacity="0.69" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_36113_220783"
        x1="388.001"
        y1="110.5"
        x2="-21.9995"
        y2="110.5"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#B0B0B0" />
        <stop offset="0.5" stopColor="#DEDEDE" />
        <stop offset="1" stopColor="#B0B0B0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_36113_220783"
        x1="388.001"
        y1="110.5"
        x2="-21.9996"
        y2="110.5"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#C9C9C9" />
        <stop offset="0.5" stopColor="white" />
        <stop offset="1" stopColor="#C9C9C9" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_36113_220783"
        x1="388.001"
        y1="110.5"
        x2="-21.9996"
        y2="110.5"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#B2B2B2" />
        <stop offset="0.5" stopColor="#E8E8E8" />
        <stop offset="1" stopColor="#B2B2B2" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_36113_220783"
        x1="16.2633"
        y1="175.697"
        x2="195.523"
        y2="592.318"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#828282" />
        <stop offset="1" stopColor="#4F4F4F" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_36113_220783"
        x1="346.93"
        y1="189.956"
        x2="80.6364"
        y2="25.3031"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.443463" stopColor="white" stopOpacity="0.18" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_36113_220783"
        x1="93.1564"
        y1="72.097"
        x2="234.333"
        y2="321.974"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#D8D8D8" stopOpacity="0.54" />
        <stop offset="1" stopColor="#A2A2A2" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_36113_220783"
        x1="346.93"
        y1="189.956"
        x2="14.0719"
        y2="-22.3925"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.814799" stopColor="white" stopOpacity="0.18" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_36113_220783"
        x1="13.0822"
        y1="191.604"
        x2="196.019"
        y2="592.331"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#7D7B88" stopOpacity="0" />
        <stop offset="1" stopColor="#797979" stopOpacity="0.63" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_36113_220783"
        x1="331.191"
        y1="197.966"
        x2="99.7447"
        y2="35.8928"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.333708" stopColor="white" stopOpacity="0.72" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_36113_220783">
        <rect width="51.5487" height="40" fill="white" transform="translate(302.451 162)" />
      </clipPath>
      <clipPath id="clip1_36113_220783">
        <rect width="51.5487" height="40" fill="white" transform="translate(302.451 162)" />
      </clipPath>
    </defs>
  </svg>
);
CardContainer.propTypes = {
  children: PropTypes.node,
};
export default CardContainer;
